import React, { Component } from "react";
import ReactDOM from "react";


class EmailSignature extends Component {
  constructor(props) {
    super(props);

    this.iframe = React.createRef();
  }

  componentDidMount() {
    this.renderIframe();
  }

  componentDidUpdate() {
    this.renderIframe();
  }

  renderIframe() {
    const content = `
    <html>
      <head>
        <title>Email Signature</title>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
      </head>
      <body style="font-family:'helvetica neue',helvetica,sans-serif;margin:0;padding:0;" >
<table width="600" height="230" border="0" cellpadding="0" cellspacing="0" style="font-family:Times">
  <tbody>
    <tr>
      <td width="200" height="230" rowspan="3"><a href="https://brandbook.services"><img src="https://brandbook.services/mail/bs.png" width="180" height="46" alt="Brandbook"></a></td>
      <td width="1" height="230" rowspan="3" style="background:rgb(0,0,0);"></td>
      <td width="399" height="120" style="padding-left:20px;vertical-align:top">
         <p style="margin:6px 0px 0px;padding:0px;font-size:24px;line-height:24px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;vertical-align:top;color:rgb(0,0,0)">${this.props.firstName.toLowerCase()}<img src="https://brandbook.services/mail/dot.png" width="6" height="6" style="margin:0 0 0 1px;"><br>${this.props.lastName.toLowerCase()}</p>
        <p style="margin:6px 0px 0px;padding:0px;font-size:12px;line-height:22px;font-family:Arial,Helvetica,sans-serif;vertical-align:top;text-transform:uppercase;color:rgb(0,0,0)">${this.props.jobTitle}</p>
        <p style="margin:0px 0px 0px;padding:0px;font-size:12px;line-height:22px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;vertical-align:top;text-transform:uppercase;color:rgb(0,0,0)"><a href="mailto:${this.props.email}" style="margin:0px;padding:0px;color:rgb(0,0,0);text-transform:none;outline:none;border:none;text-decoration:none" target="_blank">${this.props.email}</a>&nbsp;<span style="margin:0px 7px">|</span>&nbsp;<a href="tel:${this.props.mobileNumber}" style="margin:0px;padding:0px;color:rgb(0,0,0);text-transform:none;outline:none;border:none;text-decoration:none" target="_blank">${this.props.mobileNumber}</a></p>
      </td>
    </tr>
    <tr>
      <td width="399" height="35" style="padding-left:20px;vertical-align:top">
        <a href="https://www.linkedin.com/company/brandbook-services/" target="_blank"><img src="https://brandbook.services/mail/l.png" width="24" height="24" alt="LinkedIn"></a>
        <a href="https://www.facebook.com/brandbook.services" style="margin-left:5px" target="_blank"><img src="https://brandbook.services/mail/f.png" width="24" height="24" alt="Facebook"></a>
        <a href="https://www.instagram.com/brandbook.services/" style="margin-left:5px" target="_blank"><img src="https://brandbook.services/mail/i.png" width="24" height="24" alt="Instagram"></a>
      </td>
    </tr>
    <tr>
      <td width="399" height="65" style="padding-left:20px;vertical-align:top">
        <p style="margin:6px 0px 0px;padding:0px;font-size:12px;line-height:18px;font-family:Arial,Helvetica,sans-serif;vertical-align:top;color:rgb(0,0,0)">Brandbook Services Sp. z o.o. Sp. k.<br>ul. Racławicka 99, 02-634 Warszawa<br>KRS 0000860238 | REGON 387068251 | NIP 6751735834</p>
      </td>
    </tr>
  </tbody>
</table>

    </body>
    </html>
    `;

    const doc =
      this.iframe.current.contentDocument ||
      this.iframe.current.contentWindow.document;

    doc.write(content);
    doc.close();
  }

  render() {
    return <iframe ref={this.iframe} width="400" height="150" />;
  }
}

export default EmailSignature;



// WEBPACK FOOTER //
// ./src/EmailSignature.jsx